import * as React from 'react'
import { SVGProps } from 'react'

const AAVEUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <path
      d='M34.5031 33.563L26.3876 13.9424C25.9299 12.928 25.2495 12.4331 24.3526 12.4331H23.6351C22.7381 12.4331 22.0577 12.928 21.6 13.9424L18.068 22.4908H15.3959C14.5979 22.497 13.9485 23.1403 13.9423 23.9444V23.963C13.9485 24.7609 14.5979 25.4104 15.3959 25.4166H16.8309L13.4598 33.563C13.3979 33.7424 13.3608 33.928 13.3608 34.1197C13.3608 34.5774 13.5031 34.9362 13.7567 35.2146C14.0103 35.4929 14.3753 35.629 14.833 35.629C15.1361 35.6228 15.4268 35.53 15.668 35.3506C15.9278 35.1713 16.1072 34.9115 16.2495 34.6145L19.9608 25.4104H22.534C23.332 25.4042 23.9814 24.7609 23.9876 23.9568V23.9197C23.9814 23.1218 23.332 22.4723 22.534 22.4661H21.1608L23.9938 15.4084L31.7134 34.6084C31.8557 34.9053 32.0351 35.1651 32.2948 35.3444C32.5361 35.5238 32.833 35.6166 33.1299 35.6228C33.5876 35.6228 33.9464 35.4867 34.2062 35.2084C34.466 34.93 34.6021 34.5713 34.6021 34.1135C34.6082 33.928 34.5773 33.7362 34.5031 33.563Z'
      fill='url(#paint0_linear_389_6769)'
    />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <defs>
      <linearGradient
        id='paint0_linear_389_6769'
        x1='25.2519'
        y1='8.12616'
        x2='8.315'
        y2='21.1765'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#B6509E' />
        <stop offset='1' stopColor='#2EBAC6' />
      </linearGradient>
    </defs>
  </svg>
)

export default AAVEUSD
